export const PR_FEEDBACK_SETTINGS_COPY = {
  tabsLabel: "PR feedback settings",
  generalTab: "General",
  agentTab: "Agent",
  automationTab: "Automation",
  nameLabel: "Name",
  nameHelper: "This name appears in the workspace app list.",
  repositoryLabel: "Repository",
  repositoryHelper: "Listen for mentions on pull requests in this repository.",
  mentionLabel: "Mention",
  mentionHelper:
    "Leave this field empty to start a run from any human comment or review. Use @superplaneagent to require a mention.",
  ignoreBotsLabel: "Ignore bot comments",
  ignoreBotsHelper: "Do not start a run when a bot writes the mention.",
  addressAllBotsLabel: "All bots",
  addressAllBotsHelper: "Every bot comment starts pull request feedback, including bots that appear later.",
  allowedBotsLabel: "Allowed bots",
  allowedBotsHelper: "React to comments from these bots even without the mention. Use the bot login.",
  checkNamesLabel: "Status checks",
  checkNamesHelper: "Select the status checks SuperPlane must wait for and automatically attempt to fix.",
  checkNamesNone: "Select at least one status check.",
  checkNamesCatalogEmpty:
    "No status checks found on recent commits. Run CI on a recent pull request, then reopen Configure.",
  wizardChecksEmpty: "No status checks found on recent commits.",
  wizardChecksEmptyDetail: "Run CI on a recent pull request, then reopen Configure to select checks.",
  checkNamesLoading: "Loading status checks",
  checkNamesLoadingDetail: "Reading recent pull requests and the required status checks for this repository...",
  checkNamesLoadingMore: "Loading other status checks...",
  checkNamesLoadError: "SuperPlane could not load status checks from this repository.",
  wizardTitle: "Fix pull request checks",
  wizardPageTitleComments: "How should pull request comments be handled?",
  wizardPageTitleChecks: "How should failing status checks be handled?",
  wizardBackToBoard: "Back to board",
  wizardBack: "Back",
  wizardStepHumanComments: "How to handle human comments?",
  wizardStepAIComments: "Which bot comments should SuperPlane address?",
  wizardStepWhichChecks: "Which status checks should be fixed?",
  wizardStepWhichTools: "Which tools report these checks?",
  wizardMentionRequireOption: "Require @superplaneagent",
  wizardMentionRequireHelper: "Humans must mention @superplaneagent for pull request feedback.",
  wizardMentionAnyOption: "Start from any human comment",
  wizardMentionAnyHelper: "Handle any human comment or review on the pull request.",
  wizardPreviewLabel: "Example pull request comment",
  wizardPreviewPrLabel: "Pull request",
  wizardPreviewPrNumber: "#184",
  wizardPreviewCommentAuthor: "Alex",
  wizardPreviewCommentMeta: "commented",
  wizardPreviewCommentBody: "fix this and make no mistakes",
  wizardPreviewCaptionRequire: "A mention starts pull request feedback.",
  wizardPreviewCaptionAny: "Any human comment starts pull request feedback.",
  wizardPreviewBotAuthor: "coderabbitai",
  wizardPreviewBotBadge: "bot",
  wizardPreviewBotBody: "This test does not cover the new error path.",
  wizardPreviewBotIgnored: "Ignored",
  wizardPreviewBotFixing: "Fixing...",
  wizardPreviewBotIgnoreCaption: "Bot comments do not start pull request feedback.",
  wizardPreviewBotAddressCaption: "Selected bots start pull request feedback.",
  wizardPreviewChecksLabel: "Example pull request checks",
  wizardPreviewChecksHeading: "Checks",
  wizardPreviewChecksFixing: "Fixing...",
  wizardPreviewChecksIgnored: "Ignored",
  wizardPreviewChecksSelectedCaption: "Selected checks start an automatic fix.",
  wizardPreviewChecksNoneCaption: "No status checks start an automatic fix.",
  wizardPreviewChecksEmptyCaption: "No status checks found on recent commits.",
  wizardPreviewChecksNoneYet: "No status checks found on recent commits.",
  wizardPreviewChecksAttemptsOne: "Stops after 1 attempt.",
  wizardPreviewChecksAttemptsMany: "Stops after {count} attempts.",
  wizardPreviewToolsReading: "Reading {tool} logs.",
  wizardPreviewToolsNoAccess: "Not enough access",
  wizardPreviewToolsGitHub: "GitHub Actions",
  wizardPreviewToolsGrantedCaption: "SuperPlane reads CI logs from the tools you grant.",
  wizardPreviewToolsNoAccessCaption: "SuperPlane does not have enough access to fix these checks.",
  wizardPreviewToolsGitHubCaption: "SuperPlane reads GitHub Actions logs.",
  wizardPreviewToolsNoneCaption: "These checks do not need additional access.",
  wizardBotIgnoreOption: "Ignore bots",
  wizardBotAddressOption: "Choose bots",
  wizardBotsLabel: "Review bots",
  wizardBotsLoading: "Loading review bots",
  wizardBotsEmpty: "No review bots found.",
  wizardBotsLoadError: "SuperPlane could not load review bots from this repository.",
  wizardBotsFound:
    "SuperPlane scanned the most recent pull requests in the repository and found these bots. Select the bots that you want for pull request feedback.",
  wizardBotsMissing: "The bot that you use is not here?",
  wizardBotsAddManually: "Add a bot manually",
  wizardBotsAddLabel: "Add bot login",
  wizardBotsAddPlaceholder: "Add bot login, for example coderabbitai",
  wizardBotsNameInstruction: "Type the name of each review bot SuperPlane should respond to.",
  wizardBotsNameLabel: "Bot name",
  wizardBotsNamePlaceholder: "Bot name, for example coderabbitai",
  wizardBotsRemove: "Remove",
  wizardBotsAdd: "Add",
  wizardToolsDescription:
    "Connect the external tools reporting the status checks so the agent fixing the issues has enough access to troubleshoot the issues.",
  wizardToolsNoAccess: "The selected status checks do not need additional access.",
  wizardToolsGitHubActions: "These checks use GitHub Actions. SuperPlane does not need additional access.",
  wizardToolsGitHubActionsNote: "GitHub Actions does not need additional access.",
  wizardToolsUnknown:
    "SuperPlane could not match these checks to a CI tool. The agent may not have enough context to fix them.",
  wizardToolsUnselected: "Some of the checks you selected require additional access that you are not granting.",
  wizardToolsUnselectedDetail: "That prevents the agent from having enough context to fix issues correctly.",
  wizardContinue: "Continue",
  wizardFinish: "Finish",
  wizardFinishing: "Finishing...",
  wizardConnect: "Connect",
  wizardSuggestedHelper: "Based on the status checks you selected, SuperPlane needs access to these tools.",
  wizardSuggestedHelperDetail: "Grant that access so the agent can read CI logs and fix failing checks.",
  wizardOtherTools: "Other CI tools",
  maximumAttemptsLabel: "Maximum automatic fix attempts",
  wizardMaximumAttempts: "How many times should SuperPlane try before giving up?",
  maximumAttemptsHelper:
    "SuperPlane pauses automatic fixes after this many consecutive attempts. Passing checks reset the count.",
  integrationsLabel: "Additional integration access",
  integrationsHelper: "Give the agent access to CI logs from Semaphore, CircleCI, Harness, Cloudflare, or Cloudsmith.",
  integrationsMissingBefore: "If this list does not include the integration you need, go to the ",
  integrationsMissingLink: "Integrations page",
  integrationsMissingAfter: " and connect it.",
  integrationsEmpty: "None of these CI tools are connected.",
  save: "Save",
  saving: "Saving",
  delete: "Delete automation",
  deleting: "Deleting",
  keep: "Keep automation",
  confirmDelete: "Delete this automation? This cannot be undone.",
  saveError: "Could not save PR feedback settings.",
  emptyTitle: "No PR feedback automation",
  emptyBody: "Create an automation that addresses pull request feedback.",
  create: "Add feedback handler",
  creating: "Creating",
  createError: "Could not create the PR feedback automation.",
  addHandler: "Add feedback handler",
  pickerTitle: "Add feedback handler",
  pickerDescription: "Choose the signal that starts a pull request feedback run.",
  sourceTaken: "A handler for this source already exists.",
  loading: "Loading PR feedback.",
  loadError: "Could not load PR feedback.",
  retry: "Retry",
  automationEmpty: "This automation has no steps yet.",
  automationLoading: "Loading the steps.",
  automationError: "Could not load the steps.",
  retryAutomation: "Retry",
  editAutomation: "Edit automation",
  waitingForAccess: "Waiting for another activity",
} as const;
